import { css } from 'lit';

export const styles = css`
  :host {
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 720px;
    height: 750px;
    z-index: 99999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 20px;
    background: #21252b;
    color: #abb2bf;
    border-radius: 4px;
    box-shadow:
      0 16px 48px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(0, 0, 0, 0.4);
    overflow: hidden;
  }

  :host(:not([open])) {
    display: none;
  }

  /* ── Title bar ─────────────────────────────────────────── */
  .title-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px 0 0;
    background: #282c34;
    cursor: move;
    user-select: none;
    border-bottom: 1px solid #181a1f;
    flex-shrink: 0;
    min-height: 36px;
  }

  .title-bar-left {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 100%;
  }

  /* Redux-style left accent stripe */
  .title-bar-accent {
    width: 3px;
    align-self: stretch;
    background: #528bff;
    flex-shrink: 0;
  }

  .title-bar-label {
    font-size: 17px;
    font-weight: 700;
    color: #d7dae0;
    letter-spacing: 1.2px;
    text-transform: uppercase;
  }

  .title-bar-badge {
    font-size: 15px;
    color: #5c6370;
    font-weight: 400;
    letter-spacing: 0;
    text-transform: none;
  }

  .title-bar-actions {
    display: flex;
    align-items: center;
  }

  .action-btn {
    background: none;
    border: none;
    color: #5c6370;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    padding: 4px 8px;
    border-radius: 3px;
    transition:
      color 0.1s,
      background 0.1s;
  }

  .action-btn:hover {
    color: #d7dae0;
    background: #3e4451;
  }

  .close-btn {
    background: none;
    border: none;
    color: #5c6370;
    cursor: pointer;
    font-size: 27px;
    line-height: 1;
    padding: 4px 8px;
    border-radius: 3px;
    transition:
      color 0.1s,
      background 0.1s;
  }

  .close-btn:hover {
    color: #d7dae0;
    background: #3e4451;
  }

  /* ── Tab bar ───────────────────────────────────────────── */
  .tab-bar-wrapper {
    display: flex;
    background: #21252b;
    border-bottom: 1px solid #181a1f;
    flex-shrink: 0;
  }

  .tab-bar {
    display: flex;
    flex: 1;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .tab-bar::-webkit-scrollbar {
    display: none;
  }

  .tab-scroll-btn {
    flex-shrink: 0;
    background: none;
    border: none;
    color: #5c6370;
    cursor: pointer;
    font-size: 24px;
    line-height: 1;
    padding: 0 8px;
    transition:
      color 0.1s,
      background 0.1s;
  }

  .tab-scroll-btn:hover {
    color: #d7dae0;
    background: #3e4451;
  }

  .tab {
    padding: 8px 16px;
    font-size: 20px;
    font-weight: 500;
    cursor: pointer;
    color: #5c6370;
    border: none;
    background: none;
    white-space: nowrap;
    border-bottom: 2px solid transparent;
    letter-spacing: 0.2px;
    transition: color 0.1s;
  }

  .tab:hover {
    color: #abb2bf;
  }

  .tab.active {
    color: #d7dae0;
    border-bottom-color: #528bff;
  }

  .tab-badge {
    margin-left: 5px;
    font-size: 14px;
    color: #e5c07b;
    cursor: help;
    vertical-align: middle;
  }

  /* ── Content area ──────────────────────────────────────── */
  .content {
    flex: 1;
    overflow: auto;
    background: #21252b;
    scrollbar-width: thin;
    scrollbar-color: #3e4451 transparent;
  }

  .content::-webkit-scrollbar {
    width: 6px;
  }

  .content::-webkit-scrollbar-track {
    background: transparent;
  }

  .content::-webkit-scrollbar-thumb {
    background: #3e4451;
    border-radius: 3px;
  }
`;
